/**
 * ============================================================================
 * MASTER SERVICES AGGREGATOR
 * ============================================================================
 * Purpose:
 *   Central index exporting all API service clients for the Master Database.
 * ============================================================================
 */

import { createCrudService } from "../../core/services/crudServiceFactory";

export { default as authService } from "./authService";
export { default as userService } from "./userService";
export { default as accountService } from "./accountService";
export { default as databaseService } from "./databaseService";
export { default as roleService } from "./roleService";
export { default as operatorService } from "./operatorService";
export { default as countryService } from "./countryService";
export { default as menuService } from "./menuService";
export { default as loginLogService } from "./loginLogService";

export const operationService = createCrudService("operations");
